import React from "react";
import { observer } from "mobx-react";
import { PlatformViewStore } from "../../store";
import { PlatformViewForm } from "./PlatformViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type PlatformViewProps = {
  platformViewStore: PlatformViewStore;
};

export const PlatformView: React.FC<PlatformViewProps> = observer(
  ({ platformViewStore }) => {
    return (
      <div>
        <PlatformViewForm
          name={platformViewStore.nameValue}
          onPrint={(handlePrint: () => void) =>
            platformViewStore.printPlatform(handlePrint)
          }
          onCancel={() => platformViewStore.cancelPlatform()}
          onEdit={
            platformViewStore.isEditEnabled
              ? () => platformViewStore.editPlatform()
              : undefined
          }
        />
        <ErrorDialog
          open={platformViewStore.errorDialogOpened}
          title={platformViewStore.errorTitle}
          description={platformViewStore.errorDescription}
          onClose={() => platformViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
